import { createContext, useContext, FC, ReactNode } from 'react';
import { FormStep } from '../types';

export interface WizardNavigationContextValue {
  currentFormStep: FormStep;
  allFormSteps: FormStep[];
  handleNextStep: () => void;
  handlePreviousStep: () => void;
  currentStepIndex: number;
  isLastStep: boolean;
  stickyBarId: string;
}

const WizardNavigationContext = createContext<WizardNavigationContextValue | undefined>(undefined);

export interface WizardNavigationProviderProps {
  value: WizardNavigationContextValue;
  children: ReactNode;
}

export const WizardNavigationProvider: FC<WizardNavigationProviderProps> = ({
  value,
  children,
}) => {
  return (
    <WizardNavigationContext.Provider value={value}>{children}</WizardNavigationContext.Provider>
  );
};

export const useWizardNavigation = (): WizardNavigationContextValue => {
  const context = useContext(WizardNavigationContext);
  if (context === undefined) {
    throw new Error('useWizardNavigation must be used within a WizardNavigationProvider');
  }
  return context;
};
